import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"overflow-y":"hidden"} }
const _hoisted_2 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("div", {
      class: "ppt_con",
      style: {"height":"100vh"}
    }, null, -1)),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.centerDialogVisible,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.centerDialogVisible) = $event)),
      title: "关于计次体系的说明",
      width: "500",
      center: "",
      style: {"border-radius":"15px"}
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.closeDialog,
            style: {"background":"#7733f8","border":"none"}
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode(" Confirm ")
            ])),
            _: 1,
            __: [1]
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text_content" }, [
          _createElementVNode("p", null, "The sign of the process beginning is \"generate outline,\" meaning that each time an outline is generated, it counts as 1, and regenerating the outline is also considered as generating an outline. ")
        ], -1))
      ]),
      _: 1,
      __: [2]
    }, 8, ["modelValue"])
  ]))
}